<template>
  <div class="flex">
    <div :class="width >= 300 ? 'bigger-container' : width <300 ? 'smaller-container' : 'bigger-container'"  class="radial-chart">
      <vue-apex-charts v-if="showChart" :width="width ? width : '300'" :height="height ? height : '300'" :options="chartOptions" :series="series" />
      <div class="my-points">{{series[0]}}</div>
      <div class="school-points">{{series[1]}}</div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  data(){
    return{
      showChart:false,
      chartOptions: {
        chart: {
          type: 'radialBar',
        },
        // series: [],
        labels: ['Score:', 'Score:'],
        legend: {
          show: false,
          floating: true,
          fontSize: '16px',
          position: 'top',
          offsetY: 0,
          labels: {
            useSeriesColors: true,
          },
          markers: {
            size: 0
          },
          formatter: function(seriesName, opts) {
            return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex] + "%"
          },
          itemMargin: {
            horizontal: 3
          }
        },
        colors: [this.$_primary,'#fff'],
        plotOptions: {
          radialBar: {
            startAngle: -75,
            endAngle: 285,
            offsetX: 0,
            offsetY: 0,
            hollow: {
              size: '40%',
              image: undefined,
            },
            track: {
              strokeWidth: '0%',
              margin:5,
              dropShadow: {
                enabled: false,
                top: 2,
                left: 0,
                blur: 4,
                opacity: 0,
              }
            },
            dataLabels: {
              name: {
                offsetY: 10,
                color: "#fff",
                show: true,
                // fontSize: "13px"
              },
              value: {
                color: "#fff",
                // fontSize: "30px",
                show: false
              },
              total: {
                show: true,
                label: 'Score:',
                fontSize: "16px",
                color:"#fff",
                offsetY: -10,
              }
            }
          }
        },
        stroke: {
          lineCap: "round"
        },
      },
    }
  },
  components:{
    VueApexCharts,
  },
  props:{
    series:{
      typeof:Array,
      required:true
    },
    width:{
      typeof:Number,
      required:false
    },
    height:{
      typeof:Number,
      required:false
    },
    displayScore:{
      typeof:Boolean,
      required:false
    },
  },
  methods:{
    
  },
  mounted(){
    if(this.displayScore == false || this.displayScore){
      this.chartOptions.plotOptions.radialBar.dataLabels.total.show = this.displayScore;
      this.chartOptions.plotOptions.radialBar.dataLabels.name.show = this.displayScore;
    }
    this.showChart = true;
  },
  
}
</script>



<style scoped lang="scss">
.school-points, .my-points{
  position: absolute;
  background: black;
  border-radius: 50%;
  box-shadow: 0px 0px 4px 0px black;
  font-weight: bold;
  color: rgb(19, 19, 19);
  padding: 2% 3%;
}
.radial-chart{
  display: flex;
  width: fit-content;
  position: relative;
}
.smaller-container{
  .my-points{
    left: 10%;
    background-color: rgba(var(--vs-primary), 100);
    top: 31%;
  }
  .school-points{
    background-color: #fff;
    top: 31%;
    left: 33%;
  }
}

.bigger-container{
  .my-points{
    left: 14%;
    background-color: rgba(var(--vs-primary), 100);
    top: 31%;
  }
  .school-points{
    background-color: #fff;
    top: 31%;
    left: 35%;
  }
}

</style>